import React from 'react';
import { Phone } from 'lucide-react';
import { brand, navLinks } from '../mock/mock';

export default function Footer() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer
      className="relative pt-16 pb-8 px-5 md:px-8 text-[#f4e6c8]"
      style={{
        background:
          'linear-gradient(180deg, #7c130f 0%, #5a0d0a 100%)',
        borderTop: '3px solid #d9a63b',
      }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10 text-center">
          {/* Brand */}
          <div className="flex flex-col items-center">
            <h3 className="font-display font-bold text-[#f2d68a] text-2xl">Numerology King</h3>
            <p className="font-heading tracking-[0.2em] text-[#e2b84f] text-xs mt-1">
              {brand.by.toUpperCase()}
            </p>
            <p className="font-body italic text-[#f4e6c8]/80 text-lg mt-4">{brand.tagline}</p>
          </div>

          {/* Quick links */}
          <div className="flex flex-col items-center">
            <h4 className="font-heading tracking-widest uppercase text-[#f2d68a] text-sm mb-4">
              Navigate
            </h4>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <button
                    onClick={() => scrollTo(l.to)}
                    className="font-body text-lg text-[#f4e6c8]/85 hover:text-[#f2d68a] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div className="flex flex-col items-center">
            <h4 className="font-heading tracking-widest uppercase text-[#f2d68a] text-sm mb-4">
              Connect For Personalized Guidance
            </h4>
            <a
              href={`tel:${brand.whatsapp}`}
              className="flex items-center justify-center gap-2 font-body text-lg text-[#f4e6c8]/85 hover:text-[#f2d68a] transition"
            >
              <Phone size={16} /> {brand.whatsapp}
            </a>
            <p className="font-heading tracking-widest uppercase text-[#e2b84f] text-xs mt-5 mb-3">
              Follow Us
            </p>
            <div className="flex gap-3 justify-center">
              {brand.socials.map((s) => {
                const Icon = s.icon;
                return (
                  <a
                    key={s.name}
                    href={s.url}
                    target={s.url !== '#' ? '_blank' : undefined}
                    rel={s.url !== '#' ? 'noopener noreferrer' : undefined}
                    aria-label={s.name}
                    className="w-10 h-10 rounded-full flex items-center justify-center transition-transform duration-300 hover:scale-110"
                    style={{
                      background: 'radial-gradient(circle at 40% 30%, #a71c14, #5a0d0a)',
                      border: '1.5px solid #d9a63b',
                    }}
                  >
                    <Icon className="text-[#f2d68a]" size={18} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="ornament-line w-full my-8 opacity-40" />
        <p className="text-center font-body text-[#f4e6c8]/70 text-base">
          &copy; {new Date().getFullYear()} Numerology King by Vivechan Gautam. All rights reserved.
          <span className="block text-sm mt-1 opacity-70">Ancient Wisdom. Modern Guidance.</span>
        </p>
      </div>
    </footer>
  );
}
